// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { LicenseInfo } from '@mui/x-license-pro';
import moment from 'moment';
import { ScrollingProvider } from './contexts/ScrollingContext';
import { WindowDimensionProvider } from './contexts/WindowDimensionContext';
import { SnackbarProvider } from 'notistack';
import { ImpersonateProvider } from './contexts/ImpersonateContext';
import { HierarchicalCategoryProvider } from './hooks/manager/useHierarchicalCategoryMap';

// ----------------------------------------------------------------------

// Set iso moment
moment.updateLocale("en", {
  week: {
    dow: 1
  }
});

export default function App() {
  LicenseInfo.setLicenseKey('2ad7553fd49c736cc2684e1df3e72b06Tz0xMjE2NDgsRT0xNzk0NDQxNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <WindowDimensionProvider>
          <ScrollingProvider>
            <ThemeSettings>
              <SnackbarProvider maxSnack={3} autoHideDuration={4000}>
                <HierarchicalCategoryProvider>
                  <ImpersonateProvider>
                    <ProgressBarStyle />
                    <ScrollToTop />
                    <Router />
                  </ImpersonateProvider>
                </HierarchicalCategoryProvider>
              </SnackbarProvider>
            </ThemeSettings>
          </ScrollingProvider>
        </WindowDimensionProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
